/**
 * avatars/avatar-builder/builder-materials.js
 * Khởi tạo hệ thống vật liệu và texture da/quần áo cơ sở cho BlockyAvatar
 */

import * as THREE from 'three';
import { generateProceduralTexture, generateSpeciesSkinTexture } from '../avatar-presets.js';

export function createBuilderMaterials(avatar) {
  const skinMat = new THREE.MeshStandardMaterial({
    color: avatar.config.colors.skin,
    roughness: 0.8
  });

  // Texture da sinh học đặc thù chủng tộc cho bàn tay
  const speciesId = avatar.config.speciesId || avatar.config.species || avatar.config.features?.speciesId || '';
  const handCanvas = generateSpeciesSkinTexture('hands', {
    skinColor: avatar.config.colors.skin,
    speciesId
  });
  const handTex = new THREE.CanvasTexture(handCanvas);
  handTex.colorSpace = THREE.SRGBColorSpace;
  avatar.handTex = handTex;
  const handSkinMat = new THREE.MeshStandardMaterial({
    map: handTex,
    roughness: 0.75
  });
  avatar.disposables.push(handTex, handSkinMat);

  const pantsMat = new THREE.MeshStandardMaterial({
    color: avatar.config.colors.pants || '#334155',
    roughness: 0.8
  });
  const shoesMat = new THREE.MeshStandardMaterial({
    color: avatar.config.colors.shoes || '#1e293b',
    roughness: 0.7
  });

  const isBareArm = avatar.config.features.outfit === 'ao_ba_lo';
  const sleeveColor = isBareArm
    ? avatar.config.colors.skin
    : avatar.config.features.isLabCoat
      ? '#f8fafc'
      : avatar.config.colors.shirt;
  const sleeveMat = new THREE.MeshStandardMaterial({
    color: sleeveColor,
    roughness: 0.7
  });

  // Texture ngấn cổ tay giúp phân biệt rõ bàn tay và cánh tay khi mặc áo ba lỗ / cởi trần
  let bareArmMat = skinMat;
  if (isBareArm) {
    const bareCanvas = generateProceduralTexture('arm_bare', {
      skinColor: avatar.config.colors.skin,
      speciesId
    });
    const bareTex = new THREE.CanvasTexture(bareCanvas);
    bareTex.colorSpace = THREE.SRGBColorSpace;
    bareArmMat = new THREE.MeshStandardMaterial({
      map: bareTex,
      roughness: 0.8
    });
    avatar.disposables.push(bareTex, bareArmMat);
  }

  avatar.disposables.push(skinMat, pantsMat, shoesMat, sleeveMat);

  const soleMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(avatar.config.colors.shoes || '#1e293b').multiplyScalar(0.5),
    roughness: 0.9
  });
  avatar.disposables.push(soleMat);

  return {
    skinMat,
    handSkinMat,
    pantsMat,
    shoesMat,
    sleeveMat,
    bareArmMat,
    soleMat,
    isBareArm
  };
}
